<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZhiWEC/tc-custom/9781646568222.jpg?1718071477656" alt="This image is the cover for the book Courting Nightfall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Courting Nightfall
      </h1>
      <p class="bookDescription body article font2">
        <p>Zen is a darkling -- half human, half dark elf -- in a world that hates him, protected only by having been raised by the Order of the Sun to become a priest. He continues to fail to rise above being an acolyte despite having come of age and longs for a different life, one he only glimpses in dreams when he is with a mysterious, beautiful man he wishes was real.<br/><br/>After encountering an adventuring party made up entirely of other half-races, Zen is drawn to accompany them on their quest to find and destroy a fabled vampire lord. However, the pull he feels toward those lands might be more fated than he realizes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Meuwissen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8926185e